<template>
  <div id="topbar" class="bg-primary py-2" :class="{'sidebar-collapsed': sideBarCollapsed}">
    <div id="topbar-container" class="mx-auto d-flex align-items-center h-100">
      <div id="logo-container" class="pl-2 pl-sm-3 d-flex flex-row" :class="{'search-active': searchActive}">
        <Hamburger @toggleSidebar="toggleSidebar" :side-bar-collapsed="sideBarCollapsed" v-if="initialized"></Hamburger>
        <div id="logo" class="ml-auto px-3" @click="goToRoot">
          <Logo></Logo>
        </div>
      </div>
      <div id="search-container" class="d-flex flex-grow-1 px-2" v-if="initialized">
        <SearchBar class="flex-grow-1 mr-2" @active="searchActive = $event"></SearchBar>
        <div class="d-flex" :class="{'search-active': searchActive}">
          <button type="button" class="btn btn-outline-light mr-2 d-flex align-items-center justify-content-center" @click="addNote">
            <i class="fas fa-plus-circle"></i>
          </button>
          <span class="btn btn-signin btn-sm btn-outline-light h-100 d-flex align-items-center" @click="showSignInModal" v-if="!user">Sign in</span>
          <div class="dropdown h-100" v-click-outside="hideDropdown" v-else>
            <span
              class="btn btn-sm btn-outline-light dropdown-toggle align-items-center h-100 d-flex align-items-center"
              id="accountDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              @click="showDropdown=!showDropdown"
            >
              <i class="fas fa-user-cog"></i>
            </span>
            <div
              class="dropdown-menu d-block dropdown-menu-right"
              aria-labelledby="accountDropdown"
              v-if="showDropdown"
            >
              <span class="dropdown-item" @click="showAccountModal">
                <i class="fas fa-cog mr-2"></i>Account
              </span>
              <span class="dropdown-item" @click="showInfoModal">
                <i class="fas fa-info-circle mr-2"></i>Help
              </span>
              <span class="dropdown-item" @click="showFeedbackModal">
                <i class="fas fa-smile mr-2"></i>Feedback
              </span>
              <span class="dropdown-item" @click="signOut">
                <i class="fas fa-sign-out-alt mr-2"></i>Sign out
              </span>
            </div>
          </div>
        </div>
        <!-- <AddNote @add-note="addNote" class="ml-2"></AddNote> -->
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo'
// import AddNote from '@/components/AddNote'
import SearchBar from '@/components/Search/SearchBar'
import goToNote from '@/mixins/go-to-note'
import EventBus from '@/utils/event-bus'
import { signOut } from '@/utils/services'
import Hamburger from '@/components/Hamburger'
import { trackEvent } from '@/utils/analytics'

export default {
  props: ['sideBarCollapsed'],
  data() {
    return {
      searchActive: false,
      showDropdown: false
    }
  },
  components: {
    Logo,
    SearchBar,
    Hamburger
    // AddNote
  },
  mixins: [goToNote],
  computed: {
    user() {
      return this.$store.state.user
    },
    initialized() {
      return this.$store.state.initialized
    }
  },
  methods: {
    async addNote() {
      const newNote = await this.$store.dispatch('addNote', { title: 'Untitled note' })
      this.goToNote(newNote.id)
    },
    goToRoot(event) {
      const rootNote = this.$store.getters.rootNote
      this.goToNote(rootNote.id, null, event)
    },
    showSignInModal() {
      EventBus.$emit('showSignInModal')
    },
    showInfoModal() {
      EventBus.$emit('showInfoModal')
    },
    showAccountModal() {
      EventBus.$emit('showAccountModal')
    },
    showFeedbackModal() {
      EventBus.$emit('showFeedbackModal')
    },
    signOut() {
      signOut()
      trackEvent('user signs out', {
        eventCategory: 'user',
        eventAction: 'signout',
        eventLabel: this.user.email
      })
    },
    toggleSidebar() {
      this.$store.dispatch('setSideBarCollapsed', !this.sideBarCollapsed)
    },
    hideDropdown() {
      this.showDropdown = false
    }
  }
}
</script>

<style scoped lang="scss">
@import "~bootstrap/scss/mixins";

#topbar {
  z-index: 500;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: $topbar-height;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}
#topbar-container {
  position: relative;
  max-width: $app-width;
}
@include media-breakpoint-up(sm) {
  #logo-container {
    width: map-get($sidebar-width, expanded);
  }
  #logo {
    display: flex !important;
  }
  .sidebar-collapsed {
    #logo-container {
      width: initial;
    }
    #search-container {
      padding-left: 0 !important;
    }
  }
}
@include media-breakpoint-down(sm) {
  .search-active {
    display: none !important;
  }
}

#logo {
  display: none;
  text-align: center;
  align-items: center;
  justify-content: center;
}
#logo i {
  transition: all $transition-duration;
}
#logo i:hover {
  color: $primary;
  text-shadow: 0 0 5px $white, 0 0 10px $white, 0 0 15px $white,
    0 0 20px $primary, 0 0 35px $primary, 0 0 40px $primary, 0 0 50px $primary,
    0 0 75px $primary;
  cursor: pointer;
}

#logo i {
  font-size: 1.6rem;
}
span.dropdown-item {
  padding: $spacer * 0.25 $spacer;
}
span.dropdown-item,
.btn,
.note-link {
  cursor: pointer;
}
.btn-signin {
  white-space: nowrap;
}
</style>
